import React from 'react';
import { Box } from '@mui/material';

const ManagerPage: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Box sx={{ p: 3 }}>
        {/* Manager dashboard içeriği buraya gelecek */}
      </Box>
    </Box>
  );
};

export default ManagerPage; 